import { render, staticRenderFns } from "./uploadMorePicDiv.vue?vue&type=template&id=48735de0&scoped=true"
import script from "./uploadMorePicDiv.vue?vue&type=script&lang=js"
export * from "./uploadMorePicDiv.vue?vue&type=script&lang=js"
import style0 from "./uploadMorePicDiv.vue?vue&type=style&index=0&id=48735de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48735de0",
  null
  
)

export default component.exports